import styled from '@emotion/styled'
import { PrimaryLink } from 'components/Link'
import { Button } from 'components/button/Button'
import { Text } from 'components/Typography'

export const SWrapperButton = styled(Button)`
  height: 100%;
  width: 100%;
  padding: 0;

  & > span {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;

    font-weight: normal;
  }
`

export const SLinkWrapper = styled.a`
  text-decoration: none;
`

export const SImageWrapper = styled.div`
  width: 100%;
  min-height: 12.5rem;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
`

export const STextWrapper = styled.div`
  display: flex;
  flex-direction: column;
  padding: 0.75rem 1.25rem 1.5rem;
`

export const STitle = styled(Text)`
  margin-bottom: 0.75rem;
  color: var(--c-gray100);
`

export const SText = styled(Text)`
  margin-bottom: 1rem;
`

export const SLink = styled(PrimaryLink)`
  margin-right: 1rem;
  align-self: flex-end;
`
